import OrganizationService from '@/service/organization'
export default {
  getData ({commit}, payload) {
    return new Promise((resolve, reject) => {
      OrganizationService.getListOrganization(payload.page, payload.per_page, payload.status ? payload.status : '').then(res => {
        commit('setData', res.data)
        resolve(res.data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  addRoot ({commit}, payload) {
    return new Promise((resolve, reject) => {
      OrganizationService.createOrganization(payload.organization).then(res => {
        commit('addRoot', res.data.data)
        resolve(res.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  addOrganizationChidrent ({commit}, payload) {
    return new Promise((resolve, reject) => {
      OrganizationService.createOrganization(payload.organization).then(res => {
        commit('addOrganizationChidrent', res.data.data)
        resolve(res.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  destroyOrganization ({commit}, payload) {
    return new Promise((resolve, reject) => {
      OrganizationService.destroyOrganization(payload.organization).then(res => {
        commit('destroyOrganization', res.data.data)
        resolve(res)
      }).catch(error => {
        reject(error)
      })
    })
  },

  showOrganization ({commit}, payload) {
    return new Promise((resolve, reject) => {
      OrganizationService.showOrganization(payload.organization).then(res => {
        resolve(res.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  updateOrganization ({commit}, payload) {
    return new Promise((resolve, reject) => {
      OrganizationService.updateOrganization(payload.organization).then(res => {
        commit('updateOrganization', res.data.data)
        resolve(res.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  getTrashOrganization ({commit}, payload) {
    OrganizationService.getTrashOrganization(payload.page, payload.per_page).then(res => {
      if (res.status === 200) {
        commit('getTrashOrganization', res.data)
        // window.scroll(0, 0)
      }
    })
  },

  restore ({commit}, payload) {
    OrganizationService.restore(payload.data).then(res => {
      if (res.status === 200) {
        commit('restore', res.data.data)
        // window.scroll(0, 0)
      }
    })
  },

  approvalOrganization ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      OrganizationService.approvalOrganization(payload.organization).then(res => {
        if (res.status === 200) {
          commit('updateOrganization', res.data.data)
          resolve(res.data.data)
        }
      }).catch(errors => {
        reject(errors)
      })
    })
  },

  rejectOrganization ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      OrganizationService.rejectOrganization(payload.organization).then(res => {
        if (res.status === 200) {
          commit('updateOrganization', res.data.data)
          resolve(res.data.data)
        }
      }).catch(errors => {
        reject(errors)
      })
    })
  },

  getLogOrganization ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      OrganizationService.getLogOrganization(payload.organization).then(res => {
        if (res.status === 200) {
          resolve(res.data.data)
        }
      }).catch(errors => {
        reject(errors)
      })
    })
  },

  openEdit ({commit}, payload) {
    commit('openEdit')
  },
  closeEdit ({commit}, payload) {
    commit('closeEdit')
  },
  openCreateChildren ({commit}, payload) {
    commit('openCreateChildren')
  },
  closeCreateChildren ({commit}, payload) {
    commit('closeCreateChildren')
  },
  openView ({commit}, payload) {
    commit('openView')
  },
  closeView ({commit}, payload) {
    commit('closeView')
  },
  openUser ({commit}, payload) {
    commit('openUser')
  },
  closeUser ({commit}, payload) {
    commit('closeUser')
  }
}



// WEBPACK FOOTER //
// ./src/store/module/organization/actions.js